import type { FieldTypeTemplate } from '../../types/field-types';
import * as fieldTypes from './definitions';

const mappedTypes = Object.fromEntries(Object.values(fieldTypes as unknown as Record<string, FieldTypeTemplate>).map((type) => [type.id, type]));

export default mappedTypes;
